import React from 'react';
import PopoverView from './Popover';
import usePopover from './usePopover';
const PopoverHelperView = () => {
    const [popoverState, popoverActions] = usePopover();
    return React.createElement(PopoverView, { ...popoverState, onClose: popoverActions.hide });
};
export default PopoverHelperView;
